import { render } from "./YoutubeIcon.vue?vue&type=template&id=243532fe"
const script = {}
script.render = render

export default script